// extracted by mini-css-extract-plugin
module.exports = {"flex":"styles_flex__3z6iv","flex_spaceBetween":"styles_flex_spaceBetween__3h2Co","center_extAlign":"styles_center_extAlign__aFKhe"};